export enum viewStates {
    UNDEFINED = 0,
    DASHBOARD = 1,
    ASSESSMENT = 2,
    ASSESSMENT_RESULTS = 3,
    EDIT_STRATEGIES = 4,
    PRINT = 5
}

export enum assessmentViewModes {
    SEQUENTIAL = 0,
    LIST = 1
}

export enum questionTypes {
    MULTIPLE_CHOICE = 1,
    TEXT_ONLY = 2,
    MULTIPLE_CHOICE_AND_TEXT = 3,
    TABLE_OF_CONTENTS = 4,
    UNDEFINED = 99
}

export enum editModes {
    UNDEFINED = 0, // not editing
    NEW = 1, // new assessment
    EDIT = 2, // edit assessment
    ADMIN = 3 // edit questions and answers
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-risk-assessment/riskAssessment.enums.ts